import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import Sidebar from '../../layout/Sidebar'
import { connect } from 'react-redux';
import { logout } from '../../../actions/auth';
import { Navigate } from 'react-router-dom';
import { getIntervals } from '../../../actions/interval_types'
import { getServiceInterval, updateServiceInterval } from '../../../actions/service_intervals'
import Alert from '../../../components/layout/Alert';

const ServiceIntervals = ({  getIntervals, updateServiceInterval, getServiceInterval, service_interval: { service_interval, loading }, interval_type: { interval_types } }) => {


    const [formData, setFormData] = useState({
        id: '',
        intervalTypeID: ''
    });

    const { id, intervalTypeID } = formData;

    useEffect(() => {
        getIntervals();
    }, [getIntervals]);

    useEffect(() => {
        getServiceInterval();
        setFormData({
            id: loading || service_interval.id === null ? '' : service_interval.id,
            intervalTypeID: loading || service_interval.intervalTypeID === null ? '' : service_interval.intervalTypeID
        });
    }, [loading]);




    const onChange = e => setFormData({ ...formData, [e.target.name]: e.target.value });
    const onSubmit = e => {
        e.preventDefault();
        updateServiceInterval({ id, intervalTypeID });
        getServiceInterval();
    }

   
    return (
        <>
            <div className='wrapper'>
                <Sidebar />
                <div className='servicePage p-4'>
                    <h2>Business Service Intervals</h2>
                    <div className='p-4'>
                        <h5 className='mb-4'>Time interval</h5>
                        <Alert />
                        <form className='form' onSubmit={e => onSubmit(e)}>
                            <input type="hidden" className='form-control form-control-lg ' name="id" id='id' value={id} onChange={e => onChange(e)
                            } />
                            <div className='mb-5 w-25'>
                                <label htmlFor='categoryTypeID' className="form-label">Service Interval</label>
                                <select
                                    id="intervalTypeID"
                                    name="intervalTypeID"
                                    value={intervalTypeID}
                                    onChange={e => onChange(e)}
                                    className="form-select form-select-lg"

                                >
                                    <option value="">Select Interval</option>
                                    {interval_types.map((interval) => (
                                        <option value={interval.id} key={`${interval.duration}-${interval.id}`}>
                                            {interval.duration} MINUTES
                                        </option>
                                    ))
                                    }
                                </select>

                            </div>
                            <input type="submit" className="btn btn-custom" value="Save" />
                        </form>
                    </div>
                </div>
            </div>
        </>
    )
}

ServiceIntervals.propTypes = {
    logout: PropTypes.func.isRequired,
    isAuthenticated: PropTypes.bool,
    getIntervals: PropTypes.func.isRequired,
    getServiceInterval: PropTypes.func.isRequired,
    interval_type: PropTypes.object.isRequired,
    service_interval: PropTypes.object.isRequired,
}

const mapStateToProps = state => ({
    isAuthenticated: state.auth.isAuthenticated,
    interval_type: state.interval_type,
    service_interval: state.service_interval
});

export default connect(mapStateToProps, { getIntervals, updateServiceInterval, getServiceInterval, logout })(ServiceIntervals)
